import { animate, stagger, inView } from 'motion'
import ease from '@/utils/ease'

export default function Blog() {
	return {
		init() {
			// Initialize any blog-specific functionality
			this.animateVariants()
			console.log('Blog component initialized')
		},

		animateVariants() {
			const opacityVariants = this.$el.querySelectorAll('[data-animate-variant]')
			const clipPathVariants = this.$el.querySelectorAll('[data-animate-variant--clip]')

			if (!opacityVariants?.length && !clipPathVariants?.length) return

			if (opacityVariants?.length) {
				setTimeout(() => {
					inView(
						this.$el,
						() =>
							animate(
								opacityVariants,
								{ opacity: 1 },
								{ duration: 0.4, delay: stagger(0.075), easing: ease.inOutQuint },
							),
						{ amount: 'some' },
					)
				}, 200)
			}

			if (clipPathVariants?.length) {
				setTimeout(() => {
					inView(
						this.$el,
						() =>
							animate(
								clipPathVariants,
								{ opacity: 1, clipPath: 'inset(0px)' },
								{ duration: 0.6, delay: stagger(0.075), easing: ease.inOutQuint },
							),
						{ amount: 'some' },
					)
				}, 200)
			}
		},

		handleTagFilter(event) {
			const selectedValue = event.target.value

			// Use Swup navigation if available
			if (window.swup && typeof window.swup.navigate === 'function') {
				console.log('Using Swup navigate to:', selectedValue)
				window.swup.navigate(selectedValue)
			} else {
				console.log('Using regular navigation to:', selectedValue)
				window.location.href = selectedValue
			}
		},
	}
}
